export default class Uchi {
  shareId;
  title;
  sharedWithName;
  sharedWithEmail;
  createdWhen;
  expiresWhen;
  accessCodeExpires;
  accessCodeRequired;
  files;
  filename;
  externalShareId;
  views;
  downloads;
  id;
  sharedWith = [];
  accessLevel;
  driveId;
  itemId;
  owner;

  constructor(apiUchi) {
    if (apiUchi) {
      this.shareId = apiUchi.shareId ? String(apiUchi.shareId) : undefined;
      this.title = apiUchi.title;
      this.sharedWithName = apiUchi.sharedWithName;
      this.sharedWithEmail = apiUchi.sharedWithEmail;
      this.createdWhen = apiUchi.createdWhen ? new Date(apiUchi.createdWhen) : null;
      this.expiresWhen = apiUchi.expiresWhen ? new Date(apiUchi.expiresWhen) : null;
      this.accessCodeExpires = apiUchi.accessCodeExpires;
      this.accessCodeRequired = apiUchi.accessCodeRequired;
      this.files = apiUchi.files;
      this.filename = apiUchi.filename;
      this.views = apiUchi.views;
      this.downloads = apiUchi.downloads;
      this.externalShareId = apiUchi.externalShareId ? String(apiUchi.externalShareId) : undefined;
      this.id = apiUchi.id;
      this.sharedWith = apiUchi.sharedWith;
      this.accessLevel = apiUchi.accessLevel;
      this.driveId = apiUchi.graphDriveId || apiUchi.driveId;
      this.itemId = apiUchi.graphItemId || apiUchi.itemId;
      this.owner = apiUchi.owner;
    }
  }

  // Setters
  set endDate(newDate) {
    this.expiresWhen = new Date(newDate);
  }

  // Getters
  get endDate() {
    return this.expiresWhen;
  }

  get countdown() {
    const now = new Date();
    const timeLeft = this.expiresWhen - now;

    if (timeLeft > 0) {
      return {
        days: Math.floor(timeLeft / (1000 * 60 * 60 * 24)),
        hours: Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      };
    } else {
      return {
        days: 0,
        hours: 0
      };
    }
  }
}
